export default () => {
    return (
        <div id="banner">
            <div id="header">
                <h1>Брестчина туристическая</h1>
                <p className="sub">Добро пожаловать в Брестскую область!</p>
            </div>
        </div>
    );
};